import axios from 'axios';
import { api } from './api';

export interface FontVariant {
  id: string;
  name: string;
  file: string;
  url: string;
}

export interface FontFamily {
  id: string;
  name: string;
  variants: FontVariant[];
}

export interface FontListParams {
  search?: string;
}

export interface FontListResponse {
  success: boolean;
  data: FontFamily[];
}

// Canvas texts use the variant id as their font family and the toolbar reads the name from it
// ("NTTaDa-Bold"). The backend's ids are now database ids ("5"), so the file name gives that id,
// which also matches the texts of canvases saved before.
const toCanvasVariant = (variant: FontVariant): FontVariant => {
  const fileId = variant.file.replace(/\.[^.]+$/, '');
  return fileId ? { ...variant, id: fileId } : variant;
};

export const fontsService = {
  // The backend matches `search` against the family name and caps the result at 20 families.
  getFonts: async (params?: FontListParams): Promise<FontFamily[]> => {
    try {
      const search = params?.search?.trim();
      const response = await api.get<FontListResponse>('/fonts', {
        params: search ? { search } : undefined,
      });
      return (response.data.data ?? []).map((font) => ({
        ...font,
        variants: font.variants.map(toCanvasVariant),
      }));
    } catch (error) {
      console.error('Error al obtener fuentes:', error);

      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.error || 'Error al comunicarse con el servidor');
      }

      throw new Error('Error inesperado al obtener las fuentes');
    }
  },
};
